/**
 * Routes settings — `/settings` rendu par AppShell (3 panneaux).
 *
 * @remarks
 * Chaque leaf a `Component: Outlet` pour silencer le warning v7
 * "leaf route does not have an element". L'AppShell rend déjà le shell complet
 * via le registry (Sidebar + Header + PanelGroup → centerView par contexte) ;
 * l'Outlet retourne null mais sa présence suffit pour que React Router ne
 * warn plus.
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    Component: Outlet,
    handle: { context: CONTEXTS.SETTINGS, title: 'Paramètres' },
  },
];
